import { CommonModule } from '@angular/common';
import { Component, input, OnInit, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'clever-bosysreview',
    imports: [
        CommonModule,
        MatIconModule
    ],
    templateUrl: './bosysreview.html',
    styleUrl: './bosysreview.scss'
})
export class Bosysreview implements OnInit {

    review = input<any>(null);

    food = signal<number[]>([]);
    hotel = signal<number[]>([]);
    sport = signal<number[]>([]);
    location = signal<number[]>([]);
    room = signal<number[]>([]);
    service = signal<number[]>([]);
    year = signal<number>(new Date().getFullYear());

    ngOnInit(): void {
        this.initReviwlist();
    }

    async initReviwlist() {

        if (this.review().HC_Hotel > 0) {
            this.hotel.set([]);
            const tmp = Math.floor(this.review().HC_Hotel * 6 / 100);
            for (let j = 0; j < 6; j++) {
                if (j < tmp) {
                    this.hotel().push(1);
                } else {
                     this.hotel().push(0);
                }
            }
        }
        if (this.review().HC_Sport > 0) {
            this.sport.set([]);
            const tmp = Math.floor(this.review().HC_Sport * 6 / 100);
            for (let j = 0; j < 6; j++) {
                if (j < tmp) {
                    this.sport().push(1);
                } else {
                     this.sport().push(0);
                }
            }
        }
        if (this.review().HC_Gastro > 0) {
            this.food.set([]);
            const tmp = Math.floor(this.review().HC_Gastro * 6 / 100);
            for (let j = 0; j < 6; j++) {
                if (j < tmp) {
                    this.food().push(1);
                } else {
                     this.food().push(0);
                }
            }
        }
        if (this.review().HC_Lage > 0) {
            this.location.set([]);
            const tmp = Math.floor(this.review().HC_Lage * 6 / 100);
            for (let j = 0; j < 6; j++) {
                if (j < tmp) {
                    this.location().push(1);
                } else {
                     this.location().push(0);
                }
            }
        }
        if (this.review().HC_Zimmer > 0) {
            this.room.set([]);
            const tmp = Math.floor(this.review().HC_Zimmer * 6 / 100);
            for (let j = 0; j < 6; j++) {
                if (j < tmp) {
                    this.room().push(1);
                } else {
                     this.room().push(0);
                }
            }
        }
        if (this.review().HC_Service > 0) {
            this.service.set([]);
            const tmp = Math.floor(this.review().HC_Service * 6 / 100);
            for (let j = 0; j < 6; j++) {
                if (j < tmp) {
                    this.service().push(1);
                } else {
                     this.service().push(0);
                }
            }
        }
        
    }

}
